/**
 * DotLottie startup animation. File: `frontend/public/saae_preloader.lottie`.
 *
 * - `viewport`: full-screen; animation centered in the top half of the viewport (broker / login).
 * - `backofficeMainColumn`: fixed region matching the admin main column below the header — same band as
 *   {@link AdminOutletSuspenseFallback} (see {@link ADMIN_PRELOADER_BAND_LAYOUT_CLASS}).
 */

import { SaaePreloaderCore } from '@components/SaaePreloaderCore';
import {
  ADMIN_HEADER_TOP_OFFSET_CLASS,
  ADMIN_PRELOADER_BAND_LAYOUT_CLASS,
} from '@lib/adminChrome';
import { SAAE_PRELOADER_Z_INDEX_CLASS } from '@lib/saaePreloader';

export type GlobalPreloaderPlacement = 'viewport' | 'backofficeMainColumn';

export function GlobalPreloader({
  placement = 'viewport',
}: {
  placement?: GlobalPreloaderPlacement;
}) {
  if (placement === 'backofficeMainColumn') {
    return (
      <div
        className={`fixed inset-0 ${SAAE_PRELOADER_Z_INDEX_CLASS} bg-surface-web`}
        role="status"
        aria-busy="true"
        aria-live="polite"
      >
        <div
          className={`fixed inset-x-0 ${ADMIN_HEADER_TOP_OFFSET_CLASS} ${SAAE_PRELOADER_Z_INDEX_CLASS} max-[719px]:ms-0 min-[720px]:ms-[240px] bg-surface-web ${ADMIN_PRELOADER_BAND_LAYOUT_CLASS}`}
        >
          <SaaePreloaderCore />
        </div>
      </div>
    );
  }

  return (
    <div
      className={`fixed inset-0 ${SAAE_PRELOADER_Z_INDEX_CLASS} bg-surface-web`}
      role="status"
      aria-busy="true"
      aria-live="polite"
    >
      <div className={`p-4 sm:p-6 ${ADMIN_PRELOADER_BAND_LAYOUT_CLASS}`}>
        <SaaePreloaderCore />
      </div>
    </div>
  );
}
